import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'joinCommaRunners' })
export class JoinCommaRunnersPipe implements PipeTransform {
  transform(value: any[], betType: string): any {
    const blacklistForSort = [
      'pmu_tierce_standard',
      'pmu_quarte_plus_standard',
    ];
    let runnerProgramNumbers = value.map((m) => m.runnerProgramNumber);

    // sort bet types that are not on the blacklist.
    if (blacklistForSort.includes(betType) !== true) {
      runnerProgramNumbers = runnerProgramNumbers.sort((a, b) =>
        a > b ? 1 : -1
      );
    }

    return runnerProgramNumbers.join(', ');
  }
}
